import React, { useState } from 'react';
import './Recover.scss';
import Input from '../forms/inputs/Input'

import { Link } from 'react-router-dom';
import Button from '../forms/buttons/Button';
import { useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import { useTranslation } from 'react-i18next';
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";
import {PageViewLog} from "../services/interactions/page.view";


function RecoverComponent({ toaster, match, setUser }) {
    const [username, _setUsername] = useState('');
    const { t } = useTranslation(['auth']);
    const [sent, setSent] = useState(false);
    const [requestTokenReset] = useMutation(gqlSchemaLibrary.auth.mutation.resetPassword, {
        onCompleted: ({resetPassword}) => {
            AuditTrail.sendLog(PAGES.RECOVER_PASSWORD, {event: 'onSubmit', action: 'recover success'});
            setSent(true);
        }, 
        onError: (e) => {
            console.error('Invalid Email');
            AuditTrail.sendLog(PAGES.RECOVER_PASSWORD, {event: 'onSubmit', action: 'recover failed'});
            setSent(true);
        }
    });

    const submitRecover = (e) => {
        e.preventDefault();
        if (!username) {
            return;
        }
        AuditTrail.sendLog(PAGES.RECOVER_PASSWORD, {event: 'click', action: 'button recover password'});
        requestTokenReset({
            variables:{
                email: username
            }
        })
    }

    const setUsername = (value) => {
        _setUsername(value.split(' ').join('').toLowerCase());

    }

    return (
        <div id="RecoverPassword">
            <form onSubmit={submitRecover}>
                <div className="_title">
                    <Link to="/login">
                        <i className="material-icons">
                            arrow_back_ios
                        </i>
                    </Link>
                    <h1>
                        {t('text-forgot-pwd')}
                    </h1>
                </div>
                {
                    sent ?
                        <p className="_sent">
                            {t('text-recover-pwd-1')} {username} {t('text-recover-pwd-2')}<br/><br/>
                            {t('text-recover-pwd-3')}<br/><br/>
                            {t('text-recover-pwd-4')} <a className="_link" href="mailto:support@cherishhealth.com">support@cherishhealth.com</a>
                        </p>
                        :
                        <>
                            <p className="_sent">
                                {t('text-recover-pwd-5')}<br/>
                                {t('text-recover-pwd-6')}
                            </p>
                            <Input
                                label={t('email-address')}
                                placeholder={t('email-address')}
                                value={username}
                                onChange={setUsername}
                                event={PAGES.RECOVER_PASSWORD}
                            />
                            <Button type={'submit'} >
                                <span>{t('continue')}</span>
                            </Button>
                        </>
                }

            </form>
        </div>
    )
}

export default PageViewLog(RecoverComponent);
